import React, { useEffect, useState } from 'react'
import { useAppLocale } from '../../i18n/localeUtils'
import { Controller } from 'react-hook-form'
import useAuth from '../../hooks/useAuth'
import { Autocomplete, LinearProgress, TextField } from '@mui/material'
import { formatDateYYYYMMDD } from '../../packages/utils/numberFormatters'
import ShareApi from '../../api/ShareApi'
import { ShareListItem } from '@finance-lab/utils/types'

const shareApi = new ShareApi()

function ShareSelect({ name, label, companyId }: { companyId?: string; name?: string; label?: string }) {
    const { isAuthenticated } = useAuth()
    const { language } = useAppLocale()
    const [shares, setShares] = useState<ShareListItem[]>([])
    name = name || 'share'
    label = label || 'Aktie'
    useEffect(() => {
        if (!isAuthenticated) return
        async function fetchData() {
            let newShares = null
            if (companyId) {
                newShares = await shareApi.findByCompanyId(companyId)
            } else {
                newShares = await shareApi.findAll()
            }
            newShares = newShares.map((share) => {
                if (share.isDelisted) {
                    share.name = `${share.name} (avnoterat ${formatDateYYYYMMDD(share.delistedDate, { locale: language })})`
                }
                return share
            })
            // sort by name
            newShares.sort((a, b) => a.name?.localeCompare(b.name ?? '') ?? 0)
            setShares(newShares)
        }
        void fetchData()
    }, [isAuthenticated, companyId, language])
    const findShare = (shareId: string | null) => {
        if (!shareId && shares && shares.length > 0) return null // shares[0]
        return shares.find((share) => share.id === shareId)
    }
    if (!shares) return <LinearProgress />
    const defaultValue = findShare(null)
    if (shares.length > 1) {
        return (
            <Controller
                name={name}
                defaultValue={defaultValue}
                render={({ field: { onChange, onBlur, value } }) => {
                    return (
                        <Autocomplete
                            fullWidth
                            options={shares}
                            getOptionLabel={(option) => option.name}
                            value={value}
                            onBlur={onBlur}
                            onChange={(_event, newValue) => {
                                onChange(newValue)
                            }}
                            renderInput={(params) => <TextField {...params} label={label} />}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    )
                }}
            />
        )
    } else {
        return null
    }
}

export default ShareSelect
